import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";
import store from "@/store";
import MonitoringTrombolisisSvc from "@/services/MonitoringTrombolisisService";

@Module({
  store,
  dynamic: true,
  namespaced: true,
  name: "monitoring-trombolisis"
})
class MonitoringTrombolisisModule extends VuexModule {
  currentItem: any = null;
  registerId: string | number | null = null;
  schedule: any[] = [];
  scheduleSummary: any = null;
  loading = false;

  @Mutation SET_CURRENT_ITEM(val: any) {
    this.currentItem = val;
  }

  @Mutation SET_REGISTER(val: string | number | null) {
    this.registerId = val;
  }

  @Mutation SET_SCHEDULE(val: { data: any[]; summary: any }) {
    this.schedule = val.data || [];
    this.scheduleSummary = val.summary || null;
  }

  @Mutation SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Action async getByRegister(reg: string | number) {
    if (String(this.registerId) !== String(reg)) {
      this.SET_CURRENT_ITEM(null);
    }

    this.SET_REGISTER(reg);
    this.SET_LOADING(true);

    try {
      const dt = await MonitoringTrombolisisSvc.getByRegister(reg);
      const { data } = dt.data;

      if (String(this.registerId) === String(reg)) {
        this.SET_CURRENT_ITEM(data || null);
      }
    } catch {
      if (String(this.registerId) === String(reg)) {
        this.SET_CURRENT_ITEM(null);
      }
    }

    this.SET_LOADING(false);
  }

  @Action async getDetail(id: number) {
    this.SET_LOADING(true);

    try {
      const dt = await MonitoringTrombolisisSvc.find(id);
      const { data } = dt.data;
      this.SET_CURRENT_ITEM(data || null);
    } catch {
      this.SET_CURRENT_ITEM(null);
    }

    this.SET_LOADING(false);
  }

  @Action async fetchSchedule(id: number) {
    try {
      const dt = await MonitoringTrombolisisSvc.getSchedule(id);
      this.SET_SCHEDULE(dt.data);
    } catch {
      this.SET_SCHEDULE({ data: [], summary: null });
    }
  }

  @Action reset() {
    this.SET_CURRENT_ITEM(null);
    this.SET_REGISTER(null);
    this.SET_SCHEDULE({ data: [], summary: null });
  }
}

export const storeMonitoringTrombolisis = getModule(
  MonitoringTrombolisisModule
);
